export default __webpack_public_path__ + "static/media/vector.8a473683.png";